import * as Validation from "../../../common/utils/Validation";
import {addEditDPServiceActionTypes} from "../../../veritas/add-edit/constants/AddEditActionConstants";
import {checkUpdateTimeActionTypes} from "../constants/UtilityMiddlewareConstants";
import {apiActionsDPService} from "../constants/ApiMiddlewareConstants";


/**
 * This is the Middleware to validate the object generated by the add/edit DP Service
 * modal.
 * @param store, action
 * @returns Makes the call to custom validation procedure and conditionally dispatches
 * the check-update action or the post action
 */
const validateDPServiceFormMiddleware = (store) => (next) => (action) => {
    switch (action.type) {

        case addEditDPServiceActionTypes.VALIDATE_DP_SERVICE_FORM: {

            next(action);
            const {serviceObject, toDelete, authToken} = action.payload;
            const service_type = serviceObject.service_detail.dp_type;

            if (serviceObject.service_detail.service_id === "") {
                if (Validation.validateDPServiceForm(serviceObject)) {
                    if (service_type === 'kyc') {
                        store.dispatch({
                            type: apiActionsDPService.POST,
                            payload: {serviceObject, authToken}
                        });
                    } else if (service_type === 'kyb') {
                        store.dispatch({
                            type: apiActionsDPService.POST_KYB,
                            payload: {serviceObject, authToken}
                        });
                    }

                }
            }
            else {
                if (Validation.validateDPServiceForm(serviceObject)) {
                    const serviceID = serviceObject.service_detail.service_id;
                    store.dispatch({
                        type: checkUpdateTimeActionTypes.DP_SERVICE,
                        payload: { serviceID, serviceObject, toDelete, authToken}
                    });
                }
            }

            break;
        }

        default: next(action)
    }
}

export default validateDPServiceFormMiddleware;
